import { z } from "zod";
import { asSeconds } from "../units/duration.js";
const FuzzySearchResourceType = {
  /** Team performance > teammate page. */
  TeammateWithGradings: "teammate_with_gradings",
  /** Teammate x account grading slideover. */
  TeammateAccountGrading: "teammate_account_grading",
  /** Recruiting interviews. */
  Interview: "interview",
  /** Playbook criterion. */
  PlaybookCriterion: "playbook_criterion"
};
const allFuzzySearchResourceTypes = [
  FuzzySearchResourceType.TeammateWithGradings,
  FuzzySearchResourceType.TeammateAccountGrading,
  FuzzySearchResourceType.Interview,
  FuzzySearchResourceType.PlaybookCriterion
];
const fuzzySearchResourceTypeSchema = z.enum(
  allFuzzySearchResourceTypes
);
const searchableFuzzySearchResourceTypes = allFuzzySearchResourceTypes.filter(
  (resourceType) => resourceType !== FuzzySearchResourceType.PlaybookCriterion
);
const teamMemberSearchableResourceTypes = [FuzzySearchResourceType.TeammateAccountGrading];
const fuzzySearchResourceKeySchema = z.object({
  resource_type: fuzzySearchResourceTypeSchema,
  resource_id: z.string().min(1)
});
function serializeFuzzySearchResourceKey(key) {
  return `${key.resource_type}:${key.resource_id}`;
}
function parseFuzzySearchResourceKey(serializedKey) {
  const separatorIndex = serializedKey.indexOf(":");
  if (separatorIndex === -1) {
    return void 0;
  }
  const parsed = fuzzySearchResourceKeySchema.safeParse({
    resource_type: serializedKey.slice(0, separatorIndex),
    resource_id: serializedKey.slice(separatorIndex + 1)
  });
  return parsed.success ? parsed.data : void 0;
}
const durationSecondsAttribute = "duration_seconds";
function buildFuzzySearchDurationAttributes(durationSeconds) {
  return durationSeconds === void 0 ? {} : { [durationSecondsAttribute]: String(durationSeconds) };
}
function readFuzzySearchDurationSeconds(result) {
  const value = result.search_attributes[durationSecondsAttribute];
  if (value === void 0) {
    return void 0;
  }
  const durationSeconds = Number(value);
  return Number.isFinite(durationSeconds) ? asSeconds(durationSeconds) : void 0;
}
export {
  FuzzySearchResourceType,
  buildFuzzySearchDurationAttributes,
  fuzzySearchResourceKeySchema,
  fuzzySearchResourceTypeSchema,
  parseFuzzySearchResourceKey,
  readFuzzySearchDurationSeconds,
  searchableFuzzySearchResourceTypes,
  serializeFuzzySearchResourceKey,
  teamMemberSearchableResourceTypes
};
//# sourceMappingURL=search.js.map
